import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import { getUserClaims } from '../../utils/auth/unified-auth.js';
import { formatDate } from "../../utils/utils.js";
import procurment_logo from "../../assets/procurment_logo_2.png";
import procurement_text from "../../assets/procurement_text.png";
import PH_Banner_Procurement_Text from '../../assets/PH_Banner_Procurement_Text.svg'
import PH_Banner_Logo from '../../assets/PH_Banner_Logo.svg'
import PH_Hero_Key_Art from '../../assets/PH_Hero_Key_Art.svg'

function LandingPageHeader({ phase }) {
    const [userData, setUserData] = useState({})
    const [showBanner, setShowBanner] = useState(true)
    const taxonomyUrl = window.TAXONOMY_URL

    useEffect(() => {
        async function getUserInfo() {
            const userInfo = await getUserClaims()
            if (userInfo) {
                sessionStorage.setItem('userName', userInfo.userName)
                setUserData(userInfo)
            }
        }
        getUserInfo()
    }, []);

    return (
        <>
            <Row gutter={[20, 20]}>
                <Col xs={0} sm={0} md={24} lg={24} xl={24}>
                    {/* <div className="langing_page_header">
                        <img src={procurment_logo} className="procurment_logo_img" />
                        <div className="procurment_text">
                            <img src={procurement_text} className="procurement_title" />
                            <p>One Gateway, Endless Possibilities: Simplifying Procurement, One Click at a Time</p>
                        </div>
                    </div> */}
                    {/* <div className="responsive-container">
						<img src={procurment_logo} className="responsive-logo" alt="Logo" />
						<div className="responsive-text">
							<p>Dashboard uniting sales, contracting, analytics, and <br />forecasting for streamlined procurement.</p>
						</div>
					</div> */}
                    <div className="langing_page_header">
                        {
                            !showBanner ?
                                <div className="procurment_text">
                                    <div className="procurment_text_container"><div className="procurment_pepsico">PepsiCo</div><div className='procurment_procurement'>Procurement</div></div>
                                    <div className="procurement_text_description">One Gateway, Endless Possibilities: Simplifying Procurement, One Click at a Time</div>
                                </div>
                                :
                                <div style={{ display: 'flex', width: '100%', height: '160px' }}>                                   
                    
                                    <div style={{width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '2rem'}}>
                                        
                                        <div className="procurment_text">
                                            
                                            <div style={{color: '#ffffff', fontWeight: 700, fontSize: '17px', marginTop: '10px'}}>Welcome, {userData?.FirstName}</div> 
                                            <img src={PH_Banner_Logo} className="procurment_logo_img" style={{height: '40px', marginLeft: '-8px'}}/>
                                            
                                            <img src={PH_Banner_Procurement_Text} className="procurement_title" style={{height: '38px', marginBottom: '2px', marginLeft: '-15px'}}/>
                                        
                                            <p style={{color: '#FFF', fontSize: '17px', padding: '10px 0', opacity: '0.9' }}>One gateway, endless possibilities.<br/>Simplifying procurement - one click at a time.</p>
                                        
                                        </div>
                                    </div>
                                    
                                    <div style={{width: '50%', display: 'flex', justifyContent: 'flex-end'}}>
                                        <img src={PH_Hero_Key_Art} alt="banner_img" style={{  height: '100%' }} />
                                    </div>
                                </div>
                        }

                        {/* <div className="langing_page_header_show" onClick={() => setShowBanner(!showBanner)}>{showBanner ? 'Hide' : 'Show'}</div> */}
                    </div>
                </Col>
                <Col xs={12} sm={12} md={24} lg={24} xl={24}>
                    <div className="landing_page_process_overview">
                        {
                            phase === "1" ?
                                <div className="landing_page_title"> Gateway to all Apps</div> :
                                <div className="landing_page_title"> 360° KPI view and Insights</div>
                        }
                        <div className="landing_page_process_overview">
                            {/* <span style={{ color: '#3A3A3A', fontSize: 16 }}>
                                Welcome, <b>{userData?.FirstName}</b>
                            </span> */}
                            <div className="current_datetime" style={{ color: '#013771', fontSize: 12, fontweight: 400 }}>{formatDate()}</div>
                        </div>
                    </div>
                </Col>

                {/* {
                    phase === "2" &&
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className="landing_page_version_details">
                            <a href={taxonomyUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>
                                Taxonomy version currently in use: v1.0
                            </a>
                        </div>
                    </Col>
                } */}
            </Row>
        </>
    )
}

export default LandingPageHeader